import { isNullOrWhitespace } from '../../../Foundation/utils';
import { inputTemplateIDs } from './inputTemplateIDs';
import { getDefaultSelectValue } from './inputsSetups';

const selectPlaceholderText = 'SELECT placeholder text';

export const createListOptions = ({ options, selectEl, ul, onChange }) => {
    const selectText = getDefaultSelectValue();
    const initialSelect = { ItemNo: selectPlaceholderText, Name: selectText };
    const optionsWithInitialSelect = [initialSelect, ...options];

    optionsWithInitialSelect.forEach(o => {
        const { ItemNo, Name } = o;
        const li = document.createElement('li');
        const liDiv = document.createElement('div');
        const span = document.createElement('span');

        li.setAttribute("role", "option");
        li.setAttribute("data-option-value", ItemNo);
        liDiv.classList.add('liDiv');
        li.appendChild(liDiv);
        liDiv.appendChild(span);
        span.innerText = Name;
        ul.appendChild(li);

        li.addEventListener("click", function() {
            const placeholder = selectEl.querySelector('.form-select__placeholder');
            placeholder.innerText = Name;
            if(onChange){
                onChange(o);
            }
            if (ItemNo !== selectPlaceholderText) {
                selectEl.setAttribute("data-option-value", ItemNo);
                selectEl.setAttribute("value", ItemNo);
            } else {
                selectEl.setAttribute("data-option-value", '');
                selectEl.setAttribute("value", '');
            }
        });
    });
}

export const deleteNewAccessorySection = ({ id, that }) => {
    const { accessoriesTemplateID } = inputTemplateIDs;
    const container = document.getElementById(`${id}-container`);

    if(container) {
        that.fields = that.fields.filter(f => f.TemplateId !== accessoriesTemplateID);
        container.remove();
    }
}

export const createSelectWithPlaceholder = ({ fieldID, formSelectEl, placeholder, preselectedOption, selectEl, type, ul }) => {
    selectEl.classList.add('form-select', `select-input-${type}`, 'newSelect');
    selectEl.appendChild(formSelectEl);
    selectEl.dataset.fieldid = fieldID;
    placeholder.classList.add('form-select__placeholder');
    placeholder.setAttribute('role', 'button');
    placeholder.setAttribute('aria-haspopup', 'listbox');
    placeholder.setAttribute('aria-expanded', false);
    placeholder.setAttribute('tabindex', 0);
    formSelectEl.classList.add('form-select__el');
    formSelectEl.appendChild(placeholder);
    formSelectEl.appendChild(ul);
    ul.classList.add('form-select__list');
    ul.setAttribute("role", "listbox");

    if (preselectedOption) {
        placeholder.innerText = preselectedOption.Name;
        selectEl.setAttribute("value", preselectedOption.ItemNo);
    } else {
        placeholder.innerText = getDefaultSelectValue();
        selectEl.setAttribute("value", "");
    }
}

export const toggleListOnClick = ({ selectEl }) => {
    document.addEventListener("click", function(e) {
        const formSelect = selectEl.querySelector('.form-select__el');
        const isSelectClicked = e.target === selectEl.querySelector('.form-select__placeholder');

        if (formSelect.classList.contains('is-active')) {
            formSelect.classList.remove('is-active');
        } else if (isSelectClicked) {
            formSelect.classList.add('is-active');
        }
    });
}

export const setSitecorebasedOptions = ({ options, selectEl }) => {
    options.forEach((o) => {
        const optionEl = document.createElement("option");
        
        optionEl.setAttribute("value", !isNullOrWhitespace(o.Value) ? o.Value : o.Text);
        optionEl.innerHTML = o.Text;
        optionEl.setAttribute("data-valuecode", o.Value);
        selectEl.appendChild(optionEl);
    });
}

export const setAccessoriesDefaultOption = ({ defaultOption, displayedText, selectEl }) => {
    defaultOption.setAttribute("value", "");
    defaultOption.setAttribute("selected", "selected");
    defaultOption.innerHTML = displayedText;
    selectEl.appendChild(defaultOption);
}

export const setContainer = ({ container, id, sectionContainer, uniqueClass }) => {
    container.classList.add("configurator__section__fields__subsection", uniqueClass);
    container.id = id;
    sectionContainer.appendChild(container);
}

export const setFormSelect = ({ container, formSelect, uniqueValue }) => {
    formSelect.classList.add("form-select", `select-input-${uniqueValue}`);
    formSelect.setAttribute("data-select", "");
    container.appendChild(formSelect);
}

export const setLabel = ({ container, fieldLabel, inputName, name }) => {
    fieldLabel.setAttribute("for", inputName);
    fieldLabel.innerHTML = name;
    container.appendChild(fieldLabel);
}

export const setSelectEl = ({ formSelect, fieldID, id, selectEl }) => {
    selectEl.setAttribute("id", id);
    selectEl.setAttribute("data-fieldid", fieldID);
    formSelect.appendChild(selectEl);
}